
export default [
  {
    path: '/exam/single/recycle',
    name: 'recycle-bin',
    component: (r) => require(['@/v3/modules/exam/views/recycle-bin'], r),
    meta: { auth: 'Exam-Single' }
  },
  {
    path: '/exam/single/edit/:id',
    meta: { auth: 'Exam-Single' },
    name: 'examine-edit',
    component: (r) => require(['@/v3/modules/exam/views/create'], r)
  },
  {
    path: '/exam/single/import',
    meta: { auth: ['Exam-Single', 'Region-Exam-Single'] },
    component: (r) => require(['@/v3/modules/exam/views/import'], r)
  },
  {
    path: '/exam/single/Online/createSetQuestion',
    meta: { auth: 'Exam-Single' },
    component: (r) => require(['@/v3/modules/exam/views/createSetQuestion'], r)
  },
  {
    path: '/exam/single/Online/edit/:id',
    meta: { auth: 'Exam-Single' },
    name: 'online-edit',
    component: (r) => require(['@/v3/modules/exam/views/createBasic'], r)
  },
  {
    path: '/exam/single/Online/setAnswer',
    meta: { auth: 'Exam-Single' },
    component: (r) => require(['@/v3/modules/exam/views/setAnswer'], r)
  },
  {
    path: '/exam/single/answer/:id',
    meta: { auth: ['Exam-Single', 'Region-Exam-Single'] },
    name: 'examine-answer',
    component: (r) => require(['@/v3/modules/card_use/views/answer/index'], r)
  },
  {
    path: '/exam/single/answer-new/:id',
    meta: { auth: ['Exam-Single', 'Region-Exam-Single'] },
    name: 'examine-answer-new',
    component: (r) => require(['@/v3/modules/card_use/views/answer/index-new'], r)
  }
]
